import { useEffect, useMemo, useState } from 'react';
import { useDispatch } from 'react-redux';

import '../../styles/FilterForArchiveParams.css';
import Accordeon from '../CustomElements/Accordeon';
import ExpandableForm from '../CustomElements/ExpandableForm';
import FilterForArchiveKUOBZ from './FilterForArchiveKUOBZ';
import FilterForArchiveIUR from './FilterForArchiveIUR';
import FilterForArchiveServer from './FilterForArchiveServer';

import { useFilterControl } from '../../customHook/useFilterControl';
import { initArchiveSessionFromServer } from '../../redux/actions/archive.action';

function FilterForArchiveParams({ sessionId, t }) {
  // Получение функции dispatch для отправки действий в Redux store.
  const dispatch = useDispatch();

  // Начальное состояние для стейта фильтрации передаем пропсами
  const initialFormData = {
    //server
    index: '',
    alertType: '',
    routeRailName: '',
    dir: '',
    distance: '',
    warningRails: '',
    alertRails: '',
    uippsId: '',
    uippsAlertType: '',
    preciseDistance: '',
    btnAlert: false,
    btnClear: false,
    inSafeZone: '',
    fencingBtnServer: false,
    transferRails: '',
    //IUR
    iurAlertType: '',
    iurGPS: '',
    iurGSM: '',
    iurConn: '',
    //KUOBZ
    mainKuobzId: '',
    signalKuobz: '',
    safeZoneType: '',
    safeZoneWidth: '',
    kuobzGPS: '',
    kuobzGSM: '',
    kuobzConn: '',
  };
  const [formData, setFormData] = useState(initialFormData);

  // опции для селектов
  const options = useMemo(
    () => ({
      safeZoneType: [
        { value: 0, label: t?.circle || 'Круг' },
        { value: 1, label: t?.polygon || 'Полигон' },
      ],
      gsm: [
        { value: 1, label: '-60 - 0 (dBm)' },
        { value: 2, label: '-70 - -60 (dBm)' },
        { value: 3, label: '-80 - -70 (dBm)' },
        { value: 4, label: '-90 - -80 (dBm)' },
        { value: 5, label: '< -90 (dBm)' },
      ],
      connect: [
        { value: false, label: t?.no || 'Нет' },
        { value: true, label: t?.yes || 'Да' },
      ],
      alertType: [
        { value: 1, label: 'ОК' },
        { value: 5, label: t?.alert || 'Тревога' },
        { value: 2, label: t?.notification1 || 'Оповещение 1' },
        { value: 3, label: t?.notification2 || 'Оповещение 2' },
        { value: 0, label: t?.signalTypeFollowRC || 'Проследование РЦ' },
        { value: 6, label: t?.waiting || 'Ожидание' },
        { value: 4, label: t?.alertNoConnection || 'Потеря связи' },
      ],
    }),
    [t]
  );

  // хук для сброса фильтров и флага для отображения кнопки сброса
  const { resetFilters, showBtnReset } = useFilterControl(initialFormData, formData, setFormData, [
    'kuobzConn',
    'iurConn',
  ]);

  // Функция для обработки события изменения checkbox, принимает имя поля в качестве аргумента
  const handleChangeCheckbox = (fieldName) =>
    setFormData((prev) => ({
      ...prev,
      [fieldName]: !prev[fieldName],
    }));

  // фильтрация сигналов
  useEffect(() => {
    if (sessionId) {
      dispatch(initArchiveSessionFromServer(sessionId, formData));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [formData]);

  return (
    <Accordeon
      header={t?.archiveParams || 'ПАРАМЕТРЫ АРХИВА'}
      hideAbove={1650}
      qParamName={'docs_acc'}
      formData={formData}
      resetFilters={resetFilters}
    >
      <button
        type="button"
        className={`accordeon__reset-filters ${showBtnReset && 'accordeon__reset-filters_visible'}`}
        onClick={resetFilters}
      >
        <span className="accordeon__reset-filters_text">{t?.resetFiltersButton || 'Сбросить все фильтры'}</span>
        <img className="accordeon__reset-filters_icon" src="/image/close.svg" alt=""></img>
      </button>

      <form className="accordeon__form  accordeon__form_archive" id="" method="POST" action="#" autoComplete="off">
        <div className="accordeon__select-container" id="">
          <ExpandableForm title={t?.server || 'Сервер'}>
            <FilterForArchiveServer
              initialFormData={initialFormData}
              formData={formData}
              setFormData={setFormData}
              handleChangeCheckbox={handleChangeCheckbox}
              t={t}
            />
          </ExpandableForm>
          <ExpandableForm title={t?.markerIur || 'ИУР'}>
            <FilterForArchiveIUR
              initialFormData={initialFormData}
              formData={formData}
              setFormData={setFormData}
              handleChangeCheckbox={handleChangeCheckbox}
              options={options}
              t={t}
            />
          </ExpandableForm>
          <ExpandableForm title={t?.markerKuobz || 'КУОБЗ'}>
            <FilterForArchiveKUOBZ
              initialFormData={initialFormData}
              formData={formData}
              setFormData={setFormData}
              handleChangeCheckbox={handleChangeCheckbox}
              options={options}
              t={t}
            />
          </ExpandableForm>
        </div>
      </form>
    </Accordeon>
  );
}

export default FilterForArchiveParams;
